import React, { ReactElement, ReactNode } from 'react';
import { useNewUiTheme } from "../../newUiTheme";
import { useInputHelper } from "./inputHelper";
import { BaseInputProps, OnChangeCallbackType } from './types';

export type RadioButtonOption<DataType = string> = {
  value: DataType,
  label: string,
  description?: ReactNode,
  title?: string
  disabled?: boolean
}

export interface RadioButtonsGroupProps<Type> extends BaseInputProps<Type> {
  options: RadioButtonOption<Type>[];
}

export interface RadioButtonsGroupLayoutProps<Type extends string | number = string | number> {
  label: string | ReactElement,
  labelClassName?: string,
  hint?: ReactNode,
  hideLabel?: boolean,
  name: string,
  value?: Type,
  errors?: string[],
  options: RadioButtonOption<Type>[],
  onChangeCallback: OnChangeCallbackType,
}

export function RadioButtonsGroup<Type extends string | number>(props: RadioButtonsGroupProps<Type>) {
  const helper = useInputHelper<Type>(props);
  const uiTheme = useNewUiTheme();

  return (
    <uiTheme.inputs.RadioButtonsGroupLayout
      name={helper.getSource()}
      errors={helper.getErrors()}
      label={helper.getLabel()}
      labelClassName={helper.getLabelClassName()}
      value={helper.getValue()}
      onChangeCallback={helper.getOnChangeCallback()}
      options={props.options}
      hint={helper.getHint()}
      hideLabel={props.hideLabel}
    />
  );
}
